import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

function Navbar() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category/all', label: '分类' },
    { path: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="w-full z-50" role="banner">
      <nav className="w-full bg-background-50/95 backdrop-blur-sm" role="navigation" aria-label="主导航">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer" aria-label="韩漫漫画网首页">
              <span className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫漫画网
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
                    isActive(link.path)
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-48 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-950 placeholder-foreground-500 border border-background-200 focus:outline-none focus:border-primary-400 transition-colors"
                  aria-label="搜索漫画"
                />
                <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              </div>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="打开菜单"
              aria-expanded={mobileMenuOpen}
            >
              <i className={`text-xl text-foreground-950 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`whitespace-nowrap text-sm font-medium py-2 transition-colors cursor-pointer ${
                    isActive(link.path)
                      ? 'text-primary-500'
                      : 'text-foreground-700'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="relative mt-2">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-950 placeholder-foreground-500 border border-background-200 focus:outline-none focus:border-primary-400 transition-colors"
                  aria-label="搜索漫画"
                />
                <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Navbar;